import type { LucideIcon } from 'lucide-react';
import {
  Wrench,
  Globe,
  FileText,
  Code,
  Mail,
  BookOpen,
  Calendar,
  MessageCircle,
  Clock,
  Sparkles,
} from 'lucide-react';

/** Exact tool name → icon mapping for known platform tools. */
const EXACT_MATCH: Record<string, LucideIcon> = {
  ask_user: MessageCircle,
  resolve_datetime: Clock,
  activate_skill: Sparkles,
  deactivate_skill: Sparkles,
};

/** Pattern-based mapping — first match wins. */
const PATTERN_MATCH: ReadonlyArray<[RegExp, LucideIcon]> = [
  [/search|web|browse|scrape|crawl/i, Globe],
  [/file|read|write|document|upload|download/i, FileText],
  [/\bcode\b|shell|terminal|run_command/i, Code],
  [/email|mail|send_message/i, Mail],
  [/knowledge|kb|rag|embedding/i, BookOpen],
  [/calendar|schedule|event/i, Calendar],
];

/**
 * Returns an appropriate lucide-react icon for a tool name.
 * Falls back to Wrench for unrecognized tools.
 */
export function getToolIcon(toolName: string): LucideIcon {
  const exact = EXACT_MATCH[toolName];
  if (exact) return exact;
  for (const [pattern, icon] of PATTERN_MATCH) {
    if (pattern.test(toolName)) return icon;
  }
  return Wrench;
}
